// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3ma-u","box":"style_box__2JsmP","box_content":"style_box_content__3Bx8t","message":"style_message__2OVn0"};